import { Link } from "@inertiajs/react";
import React from "react";

const Footer = () => {
    return (
        <>
            <div className="py-4 text-center text-md text-black">
                <p className="dark:text-white">
                    Copyright (c) 2026 <a className="underline" href="https://dayonedevelopment.com">DayOneDevelopment.com</a> All Rights Reserved.
                </p>
                <div className="mt-2 flex justify-center gap-4 text-slate-400">
                    <Link href={route("landing.privacy.policy")} className="border-r pr-3">
                        Privacy Policy
                    </Link>
                    <Link href={route("landing.terms.conditions")} className=" pr-3">
                        Term & Condition
                    </Link>
                    {/* <a href="#" className="">
                        API Documentation
                    </a> */}
                </div>
            </div>
        </>
    );
};

export default Footer;
